// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__ea9 {
  &.isDefaultProvider__c1b:before {
    position: absolute;
    content: '';
    width: 4px;
    height: 100%;
    top: 0;
    left: 0;
    background: var(--ring-main-color);
    border-top-left-radius: inherit;
    border-bottom-left-radius: inherit;
    z-index: 1;
  }

  .deleteIcon__b5a {
    color: var(--ring-error-color);
    cursor: pointer;
    z-index: 2;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/ai/ai-settings-form/sections/ai-configuration/common/general-provider-form-wrapper.css"],"names":[],"mappings":"AAAA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,MAAM;IACN,OAAO;IACP,kCAAkC;IAClC,+BAA+B;IAC/B,kCAAkC;IAClC,UAAU;EACZ;;EAEA;IACE,8BAA8B;IAC9B,eAAe;IACf,UAAU;EACZ;AACF","sourcesContent":[".wrapper {\n  &.isDefaultProvider:before {\n    position: absolute;\n    content: '';\n    width: 4px;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: var(--ring-main-color);\n    border-top-left-radius: inherit;\n    border-bottom-left-radius: inherit;\n    z-index: 1;\n  }\n\n  .deleteIcon {\n    color: var(--ring-error-color);\n    cursor: pointer;\n    z-index: 2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__ea9`,
	"isDefaultProvider": `isDefaultProvider__c1b`,
	"deleteIcon": `deleteIcon__b5a`
};
export default ___CSS_LOADER_EXPORT___;
